import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFile02Bolt = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3337 7.33203V11.9987C13.3337 13.4715 12.1398 14.6654 10.667 14.6654H5.33366C3.8609 14.6654 2.66699 13.4715 2.66699 11.9987V3.9987C2.66699 2.52594 3.8609 1.33203 5.33366 1.33203H7.33366M13.3337 7.33203V6.66536C13.3337 3.71985 10.9458 1.33203 8.00033 1.33203H7.33366M13.3337 7.33203C13.3337 6.22746 12.4382 5.33203 11.3337 5.33203L10.9337 5.33203C10.6859 5.33203 10.5621 5.33203 10.4584 5.31562C9.88789 5.22525 9.44044 4.7778 9.35007 4.20728C9.33366 4.10363 9.33366 3.97977 9.33366 3.73203V3.33203C9.33366 2.22746 8.43823 1.33203 7.33366 1.33203M8.00032 6.9987L6.79901 8.60045C6.54962 8.93297 6.42492 9.09923 6.43366 9.22322C6.44123 9.33075 6.50034 9.42797 6.59231 9.4842C6.69836 9.54902 6.90336 9.51486 7.31336 9.44653L8.68729 9.21754C9.09728 9.1492 9.30228 9.11504 9.40833 9.17987C9.5003 9.23609 9.55941 9.33332 9.56699 9.44085C9.57572 9.56483 9.45103 9.73109 9.20164 10.0636L8.00032 11.6654",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgFile02Bolt);
export default ForwardRef;
